module.exports = __webpack_public_path__ + "static/media/av2.6daa6570.JPG";